module.exports = __webpack_public_path__ + "static/assets/7b50e9c00b6d974cd4d60e085b298db9.svg";